<template>
  <div>
    <v-alert
      :color="
        type == 'failed'
          ? color.color
          : status == 'created' || status == 'pending' || status == 'payment_pending'|| status == 'nego_submitted_buyer' || status == 'nego_processed'
          ? 'orange'
          : status == 'nego_submitted_seller'
          ? 'orange darken-4'
          : status == 'paid' ||
            status == 'pickup' ||
            status == 'processed' ||
            status == 'on_delivery' ||
            status == 'completed'   || status == 'payment_approved' || status == 'nego_approved'
          ? 'green'
          : status == 'payment_rejected' || status == 'nego_rejected'
          ? 'red' :
          color.color
      "
      class="mt-2 mb-0 py-2 rounded-lg"
      :class="color.text"
    >
      <div class="d-flex">
        <v-icon :color="type == 'failed' ? 'error' : type == 'nego' ? 'white' : 'white'">{{
          status | toIconTransaction
        }}</v-icon>
        <div class="my-auto pl-2 font-size-13">
          <span v-if="status == 'pickup'">Sedang menunggu Pickup/Drop Off</span>
          <span v-else-if="status == 'nego'">Sedang ditinjau</span>
          <span v-else>{{ status | toStatusTransaction }}</span>
        </div>
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    status: String,
  },
  computed: {
    type() {
      return this.$options.filters.toTypeTransaction(this.status);
    },
    color() {
      switch (this.type) {
        case "failed":
          return {
            color: "pink lighten-5",
            text: "red--text",
          };
        case "payment_rejected":
          return {
            color: "pink lighten-5",
            text: "red--text",
          };
        case "nego":
          return {
            color: "orange",
            text: "white--text",
          };

        default:
          return {
            color: "green lighten-5",
            text: "white--text",
          };
      }
    },
  },
  created() {},
};
</script>
